import { getAppInfo } from '../utils/appInfo'

export const useDevice = () => {
  const device = getAppInfo()

  return {
    isNativeDevice: ['android', 'ios'].includes(device.platform),
  }
}
